import { gql, useMutation } from '@apollo/client';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';
import { useTranslation } from 'react-i18next';

import { GET_APPRAISAL_INTERVIEW_BY_ID } from './get-appraisal-interview-by-id.hook';
import { GET_APPRAISAL_INTERVIEWS } from './get-appraisal-interviews.hook';

export const UPDATE_APPRAISAL_INTERVIEW = gql`
  mutation updateAppraisalInterview(
    $appraisalInterviewId: ObjectId!
    $payload: UpdateAppraisalInterviewInput!
  ) {
    updateAppraisalInterview(appraisalInterviewId: $appraisalInterviewId, payload: $payload) {
      _id
    }
  }
`;

export const useUpdateAppraisalInterview = ({ onSuccess }: { onSuccess: () => void }) => {
  const { t } = useTranslation('employee');

  const [updateInterview, { loading }] = useMutation(UPDATE_APPRAISAL_INTERVIEW, {
    refetchQueries: [GET_APPRAISAL_INTERVIEW_BY_ID, GET_APPRAISAL_INTERVIEWS],
    onCompleted: () => {
      showNotification({
        type: NOTIFICATION_TYPE.success,
        message: t('appraisalInterview.notifications.updatedInterview'),
      });
      onSuccess();
    },
  });

  return { updateInterview, loading };
};
